import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=b5bf9362&scoped=true"
import script from "./resourceList.vue?vue&type=script&lang=js"
export * from "./resourceList.vue?vue&type=script&lang=js"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=b5bf9362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bf9362",
  null
  
)

export default component.exports